import {Page, PageId} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {action, observable} from 'mobx';
import {createTransformer, ITransformer} from 'mobx-utils';

export interface IOverlaySnapshot
{
    isPinned:boolean;
    isHidden:boolean;
    page:PageId;
}

export class Overlay
{
    @observable
    public isPinned:boolean;

    @observable
    public isHidden:boolean;

    public page:Page;

    private constructor()
    {
    }

    public static create(page:Page):Overlay
    {
        const overlay:Overlay = new Overlay();

        overlay.page = page;
        overlay.isPinned = false;
        overlay.isHidden = false;

        return overlay;
    }

    @action.bound
    public setIsPinned(isPinned:boolean):void
    {
        this.isPinned = isPinned;
    }

    @action.bound
    public setIsHidden(isHidden:boolean):void
    {
        this.isHidden = isHidden;
    }

    public static toJson:ITransformer<Overlay, IOverlaySnapshot> = createTransformer((overlay:Overlay) =>
    {
        return {
            isPinned: overlay.isPinned,
            isHidden: overlay.isHidden,
            page: overlay.page.id
        };
    });

    public static fromJson(json:IOverlaySnapshot):Overlay
    {
        const page = Page.fromJson(null, null);
        page.id = json.page;

        const overlay:Overlay = new Overlay();

        overlay.page = page;
        overlay.isPinned = json.isPinned;
        overlay.isHidden = json.isHidden;

        return overlay;
    }

    public static fromJsonDeep(json:IOverlaySnapshot):Overlay
    {
        const page = Page.fromJsonDeep(null);
        page.id = json.page;

        const overlay:Overlay = new Overlay();

        overlay.page = page;
        overlay.isPinned = json.isPinned;
        overlay.isHidden = json.isHidden;

        return overlay;
    }
}
